import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  isDisabled: false, //boolean, optional // Cho biết Công ty có bị disable hay không
  ten: { //required // Tên sở trường
      vi: undefined, //string, required // Tên tiếng Việt
      en: undefined, //string, optional // Tên tiếng Anh
  },
  hotline: undefined, //string, optional // Hotline
  email: undefined, //string, optional // Email
  dien_thoai: undefined, //string, optional // Số điện thoại
  website: undefined, //string, optional // Website
  slogan: undefined, //string, optional // Slogan
  avatar_id: undefined, //IdRef, optional // Mã ảnh đại diện
  dia_chi: { //optional // Địa chỉ
      province_id: undefined, //IdRef, optional // Mã tỉnh/TP
      province_name: undefined, //string, optional // Tên tỉnh/TP
      dia_chi: undefined, //string, //required // Địa chỉ đầy đủ
  },
  giay_phep_kinh_doanh: { //optional // Giấy phép kinh doanh lữ hành
      so_giay_phep: undefined, //string, required // Số giấy phép
      noi_cap: undefined //string, optional // Nơi cấp
  },
  nguoi_quan_ly_ids: [], //array of IdRef, optional // Danh sách mã người quản lý công ty lữ hành
  uu_dai: {
    loai_hinh_uu_dai: undefined,
    gia_tri_uu_dai: undefined
  }
};

// validation form
model.validForm = {
  //id: AutoId, optional // Mã tự sinh
  isDisabled: [], //boolean, optional // Cho biết Công ty có bị disable hay không
  ten: { //required // Tên sở trường
      vi: [ValidService.required], //string, required // Tên tiếng Việt
      en: [], //string, optional // Tên tiếng Anh
  },
  hotline: [], //string, optional // Hotline
  email: [ValidService.checkEmail], //string, optional // Email
  dien_thoai: [], //string, optional // Số điện thoại
  website: [], //string, optional // Website
  slogan: [], //string, optional // Slogan
  avatar_id: [], //IdRef, optional // Mã ảnh đại diện
  dia_chi: { //optional // Địa chỉ
      province_id: [], //IdRef, optional // Mã tỉnh/TP
      province_name: [], //string, optional // Tên tỉnh/TP
      dia_chi: [ValidService.required], //string, //required // Địa chỉ đầy đủ
  },
  giay_phep_kinh_doanh: { //optional // Giấy phép kinh doanh lữ hành
      so_giay_phep: [ValidService.required], //string, required // Số giấy phép
      nơi_cap: [] //string, optional // Nơi cấp
  },
  uu_dai: {
    loai_hinh_uu_dai: [ValidService.requiredChange],
    gia_tri_uu_dai: [ValidService.required]
  },
  nguoi_quan_ly_ids: [], //array of IdRef, optional // Danh sách mã người quản lý công ty lữ hành
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

// validation các form khác
model.validFormOther = {};

model.trangThai = [{
        code: "true",
        text: "Khóa"
    },
    {
        code: "false",
        text: "Mở khóa"
    }
];


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "ten.vi": "",
            loai_diem_den: "",
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ''
        },
        valid: {
            "ten.vi": [],
            loai_diem_den: [],
            'duyet.duoc_duyet': [],
            'du_lieu_khai_bao.user_account': []
        },
        operator: {
            "ten.vi": "$vn_text=", //:regex:, $vn_text=Viêt nam
            loai_diem_den: ":regex:",
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ":regex:"
        }
    }
};

export default model;
